import { Outlet, useRouterState } from "@tanstack/react-router";
import KpisNavigation from "@/components/general/Kpis/KpisNavigation";
import { KpisHeader } from "@/components/general/Kpis/KpisHeader";
import { RouteUrl } from "@/configs/router/routes";
import { PageNotFound } from "../notFound/page";

export const KpisPage = () => {
    const pathname = useRouterState({
        select: (state) => state.location.pathname,
    });

    const validKpisPaths = [RouteUrl.Kpis, RouteUrl.KpisCurrent, RouteUrl.KpisDefault];

    const isValidKpisRoute = validKpisPaths.includes(pathname as RouteUrl);

    if (!isValidKpisRoute) {
        return <PageNotFound hideLayout />;
    }

    return (
        <main className="flex flex-col p-4">
            <KpisHeader />
            <KpisNavigation />
            <div className="mt-2">
                <Outlet />
            </div>
            <div className="md:hidden py-9" />
        </main>
    );
};
